import React from 'react'

const Projects = () => {
  return (
    <>
      <div className="detail-header">
        <h3 id="project_id">PROJECTS</h3>
        <hr />
        {/* <h4 className="h4">Tableau Projects</h4> */}
      </div>
      <div className="projects">
        <div>
          <h4>The Wealth of Nations - Tableau</h4>
          <a
            alt="The Wealth of Nations"
            href="https://github.com/SamanZahedi/DataAnalysis-Excel-/tree/master"
            target={"blank"}
          >
            <img src="./assets/excel.png" alt="The Wealth of Nations" />
          </a>
        </div>
        <div>
          <h4>Equipment inventory - Excel</h4>
          <a
            alt="Excel project"
            href="https://public.tableau.com/app/profile/saman.zahedi/viz/Thewealthofnations/Dashboard1"
            target={"blank"}
          >
            <img
              src="./assets/TheWealthOfNations.png"
              alt="Excel project"
            />
          </a>
        </div>
        <div>
          <h4>London Bus Safety - Tableau</h4>
          <a
            alt="London Bus Safety"
            href="https://public.tableau.com/app/profile/saman.zahedi/viz/TFLbussafety_16656758937660/Dashboard1"
            target={"blank"}
          >
            <img
              src="./assets/LondonBusSafety.png"
              alt="Bus Safety visualization"
            />
          </a>
        </div>
        <div>
          <h4>Change in British Industries - Tableau</h4>
          <a
            alt="BritishIndustriesChange"
            href="https://public.tableau.com/app/profile/saman.zahedi/viz/Britjobs/Dashboard"
            target={"blank"}
          >
            <img
              src="./assets/ChangeInBritIndustries.png"
              alt="BritishIndustriesChange"
            />
          </a>
        </div>
        <div>
          <h4>Change in British Industries - Power BI</h4>
          <a
            alt="Industry-change-reports"
            href="https://github.com/SamanZahedi/IndusrtyChange-PowerBI/tree/master"
            target={"blank"}
          >
            <img src="./assets/Industry-change.png" alt="weather-reports" />
          </a>
        </div>
        <div>
          <h4>Credit Card Defaults - Power BI</h4>
          <a
            alt="Credit card Default reports"
            href="https://github.com/SamanZahedi/CreditCardDefaults-PowerBI/tree/master"
            target={"blank"}
          >
            <img
              src="./assets/Creditcard-Defaults.png"
              alt="Credit card Default reports"
            />
          </a>
        </div>
        <div>
          <h4>Customer Transaction - Power BI</h4>
          <a
            alt="customer-transaction-reports"
            href="https://github.com/SamanZahedi/CustomerTransaction-PowerBI/tree/master"
            target={"blank"}
          >
            <img
              src="./assets/customer-transaction.png"
              alt="customer-transaction-reports"
            />
          </a>
        </div>
        <div>
          <h4>Financial Analysis - Power BI</h4>
          <a
            alt="financial-analysis-reports"
            href="https://github.com/SamanZahedi/FinancialAnalysis-PowerBI/tree/master"
            target={"blank"}
          >
            <img
              src="./assets/financial-analysis.png"
              alt="financial-analysis-reports"
            />
          </a>
        </div>
        <div>
          <h4>Real-time Stock Market Dashboard - Power BI</h4>
          <a
            alt="Real-time stock-market"
            href="https://github.com/SamanZahedi/Real-timeStockMarketDashboard-PowerBI/tree/master"
            target={"blank"}
          >
            <img
              src="./assets/RealTimestock-market.png"
              alt="RealTimestock-market"
            />
          </a>
        </div>
        <div>
          <h4>English learning app</h4>
          <a
            alt="English language app for Islington centre"
            href="https://islington-learning-app.netlify.app/"
            target={"blank"}
          >
            <img src="./assets/islington.png" alt="Islington" />
          </a>
        </div>
        <div>
          <h4>Youtube video list</h4>
          <a
            alt="App similar to youtube"
            href="https://youtube-video-list.netlify.app/"
            target={"blank"}
          >
            <img src="./assets/youtube-video-list.png" alt="Islington" />
          </a>
        </div>
        <div>
          <h4>Hotel booking</h4>
          <a
            alt="hotel booking app"
            href="https://cyf-samanzahedi-hotel-react.netlify.app/"
            target={"blank"}
          >
            <img src="./assets/hotels.png" alt="hotel booking app" />
          </a>
        </div>
        <div>
          <h4>TV shows</h4>
          <a
            alt="App for tv shows"
            href="https://cyf-samanzahedi-tv.netlify.app/"
            target={"blank"}
          >
            <img src="./assets/tvshow.png" alt="App for tv shows" />
          </a>
        </div>
        <div>
          <h4>Cakes website</h4>
          <a
            alt="App for ordering cakes"
            href="https://yumcakes.netlify.app/"
            target={"blank"}
          >
            <img src="./assets/yumcakes.png" alt="cakes pictures" />
          </a>
        </div>
      </div>
    </>
  );
}

export default Projects